import React, { FC } from "react"
import parse from "html-react-parser"
import { FormMessageProps } from "./types"
import { FormMessageWrapper } from "./styles"

const FomMessage: FC<FormMessageProps> = ({
    message,
    type,
    dense = false,
    ...props
}) => {
    return <FormMessageWrapper dense={dense} type={type} {...props}>
        {parse(message)}
    </FormMessageWrapper>
}

export default FomMessage
